import { BehaviorSubject } from 'rxjs';

const partnerSubject = new BehaviorSubject(null);

function getPartner() {
    let data = localStorage.getItem('partner');
    if (data === 'undefined' || data == null) {
        return null;
    }

    let jsonPayload = JSON.parse(data);
    partnerSubject.next(jsonPayload);

    return jsonPayload;
}

function setPartner(id, name) {
    localStorage.setItem('partner', JSON.stringify({ partnerId: id, partnerName: name }));
    partnerSubject.next({ partnerId: id, partnerName: name });
}

function clearPartner() {
    localStorage.removeItem('partner');
    partnerSubject.next(null);
}

const AppCache = {
    getPartner,
    setPartner,
    clearPartner,
    partnerObservable: partnerSubject.asObservable(),
    partner: partnerSubject.value

}

export default AppCache;